// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".errModalContent___RzioJ{font-size:16px;padding:24px 0;line-height:24px}.containerClass___4aojQ{width:464px}\n", "",{"version":3,"sources":["webpack://./src/components/DeleteRuleModal/DeleteRuleErrorModal.css"],"names":[],"mappings":"AAAA,yBACI,cAAA,CADJ,cAAA,CAGI,gBAAA,CAEJ,wBACI,WAAA","sourcesContent":[".errModalContent {\n    font-size: 16px;\n    padding: 24px 0;\n    line-height: 24px;\n}\n.containerClass {\n    width: 464px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errModalContent": "errModalContent___RzioJ",
	"containerClass": "containerClass___4aojQ"
};
export default ___CSS_LOADER_EXPORT___;
